<template>
  <ClientOnly>
    <RevTooltip v-if="isSmallScreen" position="right">
      <template #trigger="{ show, hide }">
        <RevButtonIcon
          :alternative-text="text"
          :icon
          :target
          :to
          :variant="buttonIconVariant"
          @focusin="show"
          @focusout="hide"
          @mouseenter="show"
          @mouseleave="hide"
        />
      </template>
      {{ text }}
    </RevTooltip>

    <RevButtonBase
      v-else
      :aria-label="text"
      :class="buttonBaseClassNames"
      :target
      :title="text"
      :to
    >
      <component :is="icon" class="shrink-0" />
      <span class="truncate">
        {{ text }}
      </span>
    </RevButtonBase>
  </ClientOnly>
</template>

<script setup lang="ts">
import { type Component, computed } from 'vue'

import { tw } from '@backmarket/utils/string/tw'
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { RevTooltip } from '@ds/components/Tooltip'
import type { Location } from '@ds/types/Location'

import { useScreenSize } from '../../composables/useScreenSize'

const props = withDefaults(
  defineProps<{
    icon: Component
    target?: string
    text: string
    to: Location
    destructive?: boolean
  }>(),
  {
    target: undefined,
    destructive: false,
  },
)

const { isSmallScreen } = useScreenSize()

const buttonIconVariant = computed(() =>
  props.destructive ? 'secondaryDestructive' : 'secondary',
)

const buttonBaseClassNames = computed(() => [
  tw`flex items-center gap-8 px-24 py-[11px] no-underline`,
  props.destructive
    ? tw`text-action-danger-hi hover:bg-action-danger-min-hover`
    : tw`text-action-default-hi hover:bg-action-default-min-hover`,
])
</script>
